// extracted by mini-css-extract-plugin
module.exports = {"lang":"ke","langWrap":"kf","item":"kg","itemCurrent":"kh"};